<template>
  <div id='transaction'>
    <div>
      <Row>
        <Col span="6" class="fontsize26">
          派車單-- {{transferListSelf[0].name}}
        </Col>
        <Col span="12">
          <Select v-model="year" style="width:70px" @on-query-change="getTransaction">
            <Option v-for="y in yearList" :value="y" :key="y">{{ y }}</Option>
          </Select>
          年
          <Select v-model="month" style="width:50px" @on-query-change="getTransaction">
            <Option v-for="m in monthList" :value="m" :key="m">{{ m }}</Option>
          </Select> 
          月
        </Col>
      </Row>
      <Row>
        <Col span="6">
          <transactionIcon>
            <div slot="icon">
              {{statistic.monthlyCancelCount}}
              <Icon type="close"></Icon>
            </div>
            <div slot="main">司機/乘客取消</div>
            <div slot="note">未完工之訂單</div>
          </transactionIcon>
        </Col>
        <Col span="6">
          <transactionIcon>
            <div slot="icon">
              {{statistic.systemTotal}}
              <Icon type="android-desktop"></Icon>
            </div>
            <div slot="main">系統</div>
            <div slot="note">系統自動派車</div>
          </transactionIcon>
        </Col>
        <Col span="6">
          <transactionIcon>
            <div slot="icon">
              {{statistic.total}}
              <i class="fas fa-plus-square"></i>
            </div>
            <div slot="main">總計</div>
            <div slot="note">系統叫車 = 完成之訂單</div>
          </transactionIcon>
        </Col>
        <Col span="6">
          <transactionIcon>
            <div slot="icon">
              {{statistic.successRate}}%
              <i class="fas fa-chart-bar"></i>
            </div>
            <div slot="main">成功率</div>
            <div slot="note">完工/所有訂單 = 完成之訂單</div>
          </transactionIcon>
        </Col>
      </Row>
      <div class="unusual fontsize24">異常單: {{statistic.unusual}}</div>
      <div class="content-title">
        <Icon type="android-settings"></Icon>派車單
        <div class="border"></div>
      </div>
      <Table border :columns="columnSelf" :data="transferListSelf"></Table>
      <div class="content-title">
        <Icon type="android-settings"></Icon>紀錄
        <div class="border"></div>
      </div>
      <Table border :columns="column" :data="transferListView"></Table>
    </div>
  </div>
</template>

<script>
import { API } from "@/assets/config";
import transactionIcon from "./transactionIcon";

export default {
  name: "transaction",
  // props: ["name"],
  components: {transactionIcon},
  data() {
    return {
      id: this.$route.params.id,
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      yearList: [2015],
      monthList: [1,2,3,4,5,6,7,8,9,10,11,12],
      kw:"",
      columnSelf: [
        { title: '客戶名稱', key: 'name' },
        { title: '轉出', key: 'transferOut' },
        { title: '轉入', key: 'transferIn' },
        { title: '正常單', key: 'normal' },
      ],
      column: [
        { title: '客戶名稱', key: 'name' },
        { title: '轉出XX', key: 'transferOut' },
        { title: '轉入XX', key: 'transferIn' }
      ],
      transferList: [],
      transferListView: [],
      transferListSelf: [{name: ''}],
      statistic: {
        systemTotal: 0,
        total: 0,
        monthlyCancelCount: 0,
        successRate: 0,
        unusual: 0
      }
    };
  },
  async created() {
    this.initYearMonth()
    try {
      await this.getTransaction()
    } catch (error) {
      this.errorHandle(error)
    }
  },
  methods: {
    initYearMonth() {
      let now = new Date()
      let year = now.getFullYear()
      let month = now.getMonth() + 1
      while(this.yearList[this.yearList.length - 1] < year) {
        this.yearList.push(this.yearList[this.yearList.length - 1] + 1)
      }
    },
    async getTransaction() {
      let res = await this.axios.get(API.transactions + `${this.id}?date=${this.year}-${this.month}-1`)
      console.log(res)
      
      this.statistic = res.data.statistic
      if(!this.statistic.successRate)
        this.statistic.successRate = 0

      this.transferList = res.data.transferList
      this.transferListSelf = this.transferList.filter(transfer => transfer.id === this.id)
      this.transferListView = this.transferList.filter(transfer => {
        return transfer.id !== this.id && (transfer.transferOut !== 0 || transfer.transferIn !== 0)
      })
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.ivu-row {
  margin: 10px 0px;
}
.unusual {
  padding: 10px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/transaction/transaction.vue